import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

import { NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-vendor-detail-card',
  templateUrl: './vendor-detail-card.component.html',
  styleUrl: './vendor-detail-card.component.scss'
})
export class VendorDetailCardComponent {

  @Input() vendor: any;

  FRAPPE_API_URL = environment.FRAPPE_API_URL;
  borderColor:string=''

  constructor(private router: Router) {

   }

  ngOnInit(): void {
    if (this.vendor.status==='PENDING_APPROVER_1' || this.vendor.status==='PENDING_APPROVER_2' || this.vendor.status==='PENDING_REVIEW' || this.vendor.status=== 'PENDING_CPO_APPROVAL'){
      this.borderColor='border-orange-500'
    }
    else if(this.vendor.status==='APPROVED'){
      this.borderColor='border-green-500'
    }
    else if(this.vendor.status==='REJECT'){
      this.borderColor='border-red-500'
    }
    else{
      this.borderColor='border-500'
    }
  }

  onDetail(get_user:string,status:string,businessName:string){
    // this.router.navigate(['/vendor-detail', businessName]);
    const navigationExtras: NavigationExtras = {
      state: {
        get_user: get_user,
        status:status,
      }
    };

    this.router.navigate(['/view-vendor-details',businessName], navigationExtras);
  }
}
